<template>
  <div class="download_main" :style="{'width':screen.width + 'px','height':screen.height + 'px'}">
    <div class="head1">管家小奇APP</div>
    <div class="head2">开启您的智能生活</div>
    <div class="head3">
      <div class="b11" />
      <div class="b1" @click="onDownloadClick('http://www.51ohh.com/app/ohhwatch.apk')"></div>
      <div class="b2" @click="onDownloadClick('https://apps.apple.com/cn/app/id1091448612')"></div>
    </div>
    <div class="bottom">
      <div class="p">
        <p>西 安 奇 妙 电 子 科 技 有 限 公 司</p>
        <p>xi’an qimiao electronic technology co.,limited</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Joky, JokyGetScreen } from "@/joky";
export default {
  name: "home-view",
  data() {
    return {
      screen: Joky.screen
    };
  },
  methods: {
    onDownloadClick(url) {
      window.location.href = url;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../styles/theme.styl';

.download_main {
  wh(100%, 100%);
  backGround('../assets/download/4.png');
  position: relative;
  overflow-y: hidden;
  text-align: center;

  .head1 {
    margin-top: 0.3rem;
    color: rgb(67, 124, 255);
    font-size: 0.7rem;
  }

  .head2 {
    margin-top: 0.2rem;
    color: #888888;
    font-size: 0.4rem;
  }

  .head3 {
    wh(6.5rem, 8rem);
    display: block;
    margin: auto;
    margin-top: 0.2rem;
    backGround('../assets/download/3.png');
    text-align: left;

    .b11 {
      wh(3rem, 3.4rem);
    }

    .b1 {
      margin-left: 0.4rem;
      wh(2.1rem, 0.6rem);
      backGround('../assets/download/1.png');
    }

    .b2 {
      wh(2.1rem, 0.6rem);
      margin-top: 0.3rem;
      margin-left: 0.4rem;
      backGround('../assets/download/2.png');
    }
  }

  .bottom {
    width: 100%;
    bottom: 0px;
    position: fixed;

    .p {
      font-size: 0.25rem;
      line-height: 0.5rem;
      color: #101010;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue